import { login, logout, getInfo } from '@/api/auth';
import {isLogged, setToken, setLogged, removeToken, setRoles, getRoles} from '@/utils/auth';
import router, { resetRouter } from '@/router';
import store from '@/store';
import {Message} from "element-ui";
// import request from '@/utils/request';

const state = {
  id: null,
  user: null,
  token: isLogged(),
  name: '',
  account: '',
  avatar: '',
  introduction: '',
  roles: getRoles() ?? [],
  permissions: [],
};

const mutations = {
  SET_ID: (state, id) => {
    state.id = id;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
    // request.defaults.headers.common["Authorization"] = "Token " + token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_ACCOUNT: (state, account) => {
    state.account = account;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
    setRoles(roles);
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
};

const actions = {
  // user login
  // eslint-disable-next-line no-unused-vars
  login({ commit }, userInfo) {
    console.log("XX LOGIN TRONG USER STORE");
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
  // eslint-disable-next-line no-unused-vars
        .then(response => {
          const token = response.auth_token;
          commit('SET_TOKEN', token);

          setLogged('1');
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  // get user info
  // eslint-disable-next-line no-unused-vars
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {

          if (!response) {
            reject('Verification failed, please Login again.');
          }

          const { username, id, email } = response;
          // const { roles, account, name, avatar, introduction, permissions, id } = data;
          const roles = [response.role.code];
          const permissions = response.role.permissions;

          // set data theo format folow cu
          response.roles = roles;
          response.permissions = permissions;

          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            Message.error('Bạn chưa được cấp quyền truy cập ứng dụng này'); // co the disable user bang cach huy cap quyen

            reject('getInfo: roles must be a non-null array!');
          }

          
          commit('SET_USER', response); // su dung nhieu
          commit('SET_ROLES', roles);
          commit('SET_PERMISSIONS', permissions);
          commit('SET_NAME', username);
          commit('SET_ACCOUNT', username);
          commit('SET_AVATAR', '');
          commit('SET_INTRODUCTION', email);
          commit('SET_ID', id);

          resolve(response);
        })
        .catch(async error => {
            // kiem tra neu 401 thi fail
            if (error != null && error.status === 401) {
                // reset session
                await store.dispatch('user/resetToken');
                // redirect to no role screen
            }
            reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          removeToken();
          resetRouter();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },

  // Dynamically modify permissions
  // eslint-disable-next-line no-unused-vars
  changeRoles({ commit, dispatch }, role) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      // const token = role + '-token';

      // commit('SET_TOKEN', token);
      // setLogged(token);

      // const { roles } = await dispatch('getInfo');

      const roles = [role.name];
      const permissions = role.permissions.map(permission => permission.name);
      commit('SET_ROLES', roles);
      commit('SET_PERMISSIONS', permissions);
      resetRouter();

      console.log("user change role");
      // generate accessible routes map based on roles
      const accessRoutes = await store.dispatch('permission/generateRoutes', { roles, permissions });
     
      // dynamically add accessible routes
      router.addRoutes(accessRoutes);

      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
